import { render } from "./OidoModalFooter.vue?vue&type=template&id=d717e2ca&scoped=true"
import script from "./OidoModalFooter.vue?vue&type=script&lang=js"
export * from "./OidoModalFooter.vue?vue&type=script&lang=js"

import "./OidoModalFooter.vue?vue&type=style&index=0&id=d717e2ca&scoped=true&lang=css"
import "./OidoModalFooter.vue?vue&type=style&index=1&id=d717e2ca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d717e2ca"]])

export default __exports__